import { ClubPage } from "components/ClubPage"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { Wrapper } from "components/Wrapper"
import { PartnerCard } from "domains/partner/PartnerCard"

export function ClubPartnerIndexPage({ partners }) {
  const translator = useTranslator()

  return (
    <ClubPage
      title={translator.trans("club.partner.index.title", null, "pages")}
    >
      <Wrapper>
        {partners.length > 0 ? (
          <div className="space-y-4">
            <ul className="grid gap-2 sm:grid-cols-2 md:grid-cols-3 md:gap-4 lg:grid-cols-4">
              {partners.map((partner) => {
                return (
                  <li key={partner.id}>
                    <PartnerCard partner={partner} />
                  </li>
                )
              })}
            </ul>
          </div>
        ) : (
          <Text tag="p">
            {translator.trans("club.partner.index.emptyMessage", null, "pages")}
          </Text>
        )}
      </Wrapper>
    </ClubPage>
  )
}
